
import { AccountModule, ServiceDeskType } from '@/store/modules/account.module';
import { defineComponent, computed, useAttrs, ref } from 'vue';

/**
 * @description 选择部门 平铺式(单选)
 * */
export default defineComponent({
  props: {
    modelValue: {
      type: [Number, String]
    },
    optionIds: { // 选项从这儿取
      type: Array
    },
    hadSunloginWeb: {
      type: Boolean,
      default: false
    },
    // serviceDeskStatus 查询客服组启用状态，1启用，0停用，不传就查询所有状态的数据
    serviceDeskStatus: {
      type: String
    }
  },
  setup (props, { emit }) {
    const attrs = useAttrs()
    const serviceDeskList = ref<Array<ServiceDeskType>>([]);
    const serviceDeskId = computed({
      get () {
        return props.modelValue
      },
      set (value) {
        emit('update:modelValue', value)
      }
    })

    const showList = computed(() => {
      if (props.optionIds) {
        return serviceDeskList.value.filter(item => (props.optionIds as Array<any>).includes(item.id))
      }
      return serviceDeskList.value
    })

    if (props.serviceDeskStatus !== undefined) {
      AccountModule.getServiceDeskList({ serviceDeskStatus: props.serviceDeskStatus }).then((res):void => {
        serviceDeskList.value = res as Array<ServiceDeskType>;
      });
    } else {
      AccountModule.getServiceDeskList().then((res):void => {
        serviceDeskList.value = res as Array<ServiceDeskType>;
      });
    }

    return {
      attrs,
      serviceDeskId,
      showList,
      serviceDeskList
    }
  }
})
